import React from 'react';
import { Button } from '@/components/ui/button';

export interface ActionsSectionProps {
  onApply: () => void;
  onCancel: () => void;
  onClear?: () => void;
  isClearDisabled?: boolean;
}

export const ActionsSection: React.FC<ActionsSectionProps> = ({
  onApply,
  onCancel,
  onClear,
  isClearDisabled = false,
}) => {
  return (
    <div className="flex items-center justify-between gap-2 pt-2 border-t border-border">
      {onClear ? (
        <Button
          size="sm"
          variant="outline"
          onClick={onClear}
          disabled={isClearDisabled}
          className="h-7 px-2 text-xs"
        >
          Clear
        </Button>
      ) : (
        <span />
      )}
      <div className="flex items-center gap-1">
        <Button
          size="sm"
          variant="outline"
          onClick={onCancel}
          className="h-7 px-2 text-xs"
        >
          Cancel
        </Button>
        <Button size="sm" onClick={onApply} className="h-7 px-2 text-xs">
          Apply
        </Button>
      </div>
    </div>
  );
};
